export const PROFILE_UPDATE_CONFIRM_PATH = '/confirm-profile-update';
export const PROFILE_UPDATE_CONFIRM_CODE_PARAM = 'code';
export const PROFILE_UPDATE_CONFIRM_STATUS_PARAM = 'profileUpdateConfirm';

export type ProfileUpdateConfirmStatus = 'success' | 'error';

export function readProfileUpdateConfirmCode(searchParams: URLSearchParams): string | null {
    const code = searchParams.get(PROFILE_UPDATE_CONFIRM_CODE_PARAM)?.trim() ?? '';
    return code || null;
}

export function readProfileUpdateConfirmStatus(searchParams: URLSearchParams): ProfileUpdateConfirmStatus | null {
    const status = searchParams.get(PROFILE_UPDATE_CONFIRM_STATUS_PARAM);
    return status === 'success' || status === 'error' ? status : null;
}

export function buildProfileUpdateConfirmationUrl(publicOrigin: string): string {
    return `${publicOrigin.replace(/\/$/, '')}${PROFILE_UPDATE_CONFIRM_PATH}/?${PROFILE_UPDATE_CONFIRM_CODE_PARAM}=`;
}

export function buildProfileUpdateConfirmHomeRedirect(status: ProfileUpdateConfirmStatus): string {
    return `/?${PROFILE_UPDATE_CONFIRM_STATUS_PARAM}=${status}`;
}
